import {
  DigitalMarketingMain_CoverImage,
} from "../../../assets/data/Imagedata";

import {
  DefaultIcon,
} from "../../../assets/data/icon_data";


export const SearchEngineOptimizationPageDetails = {
  SeoName: {
    seotitle: "SearchEngineOptimizationPageDetailsseo",
  },
  title: "Search Engine Optimization (SEO) Services",
  subtitle:
    "Boost your website's visibility, rankings, and traffic with our expert SEO strategies tailored for long-term digital growth.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Dominate Search Engine Rankings",
    heading: "SEO Services to Drive Organic Traffic & Leads",
    description:
      "Cyber Space Digital offers data-driven SEO services designed to increase your websites organic visibility, improve keyword rankings, and grow your qualified traffic consistently.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Technical SEO Audit & Fixes",
      description: "Optimize site structure, speed, and crawlability.",
      details: [
        "Site Health & Crawl Report",
        "Speed & Core Web Vitals Fixes",
        "Mobile-Friendliness & Indexing",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Keyword Research & Mapping",
      description: "Identify profitable keywords aligned with your business.",
      details: [
        "Short & Long-Tail Keywords",
        "Competitor Keyword Analysis",
        "Keyword-to-Page Strategy",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "On-Page SEO Optimization",
      description: "Improve meta tags, content, images, and internal links.",
      details: [
        "Title, Meta Description, H1-H6",
        "Content Optimization & Keyword Density",
        "Schema Markup Integration",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Link Building & Outreach",
      description: "Build high-quality backlinks to boost authority.",
      details: [
        "Guest Posts & Blogger Outreach",
        "Niche Directory Submissions",
        "DA/DR-Based Link Building",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Local SEO Optimization",
      description: "Rank higher in local map packs and city-based searches.",
      details: [
        "Google Business Profile Optimization",
        "NAP Consistency & Local Citations",
        "Location-Specific Pages",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Monthly SEO Reporting & Tracking",
      description: "Transparent reporting and KPIs tracking.",
      details: [
        "Keyword Rank Tracking",
        "Traffic & Conversion Reports",
        "Ongoing Recommendations",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter SEO Plan",
      price: "",
      features: [
        "5 Keywords",
        "On-Page Optimization",
        "Monthly Reporting",
        "Technical Audit",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth SEO Plan",
      price: "",
      features: [
        "15 Keywords",
        "Backlinks & Outreach",
        "Local SEO",
        "Monthly Reports + Strategy",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise SEO",
      price: "",
      features: [
        "30+ Keywords",
        "Full SEO Suite + Custom Strategy",
        "Conversion Tracking",
        "Dedicated SEO Expert",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "How long does SEO take to show results?",
      answer:
        "SEO is a long-term strategy. Most clients see noticeable improvements in 3 to 6 months depending on competition and goals.",
    },
    {
      question: "Do you guarantee top rankings?",
      answer:
        "We dont promise guaranteed #1 positions, but we commit to ethical strategies that improve visibility and rankings steadily.",
    },
    {
      question: "Will you provide reports?",
      answer:
        "Yes, we offer monthly performance reports including keyword rankings, traffic, and recommendations.",
    },
    {
      question: "Is local SEO included?",
      answer:
        "Yes. Our plans include Google Business Profile optimization, citation building, and location-based content.",
    },
    {
      question: "Can you optimize my existing website?",
      answer:
        "Absolutely. We can perform an audit and implement fixes on your current site or work with your developer.",
    },
    {
      question: "Do you use AI tools or manual SEO?",
      answer:
        "We blend automation and AI tools with manual strategies to deliver efficient and effective SEO results.",
    },
  ],
};
export const ContentMarketingPageDetails = {
  SeoName: {
    seotitle: "ContentMarketingPageDetailsseo",
  },
  title: "PR & Media Strategy",
  subtitle:
    "Build authority, manage reputation, and gain media coverage with strategic PR solutions.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Fuel Your Growth with Content",
    heading: "Strategic Content Marketing for Brand Awareness & Conversions",
    description:
      "Cyber Space Digital crafts content that educates, entertains, and converts. From blogs to ebooks and social posts, we help brands tell their story and drive measurable results.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "PR Strategy Planning",
      description: "Custom PR roadmaps to build brand authority and trust.",
      details: [
        "Brand positioning strategy",
        "Target media identification",
        "Messaging & statement drafting",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "News Article Publishing",
      description:
        "Get your stories published on high-authority news platforms.",
      details: [
        "Regional & National coverage",
        "Strategic story placement",
        "Guaranteed news mentions",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Media Coverage",
      description:
        "Comprehensive media presence across digital and traditional channels.",
      details: [
        "Interviews & press meets",
        "Media relationship management",
        "Event media coverage",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Online Reputation Management",
      description: "Monitor and improve your brand's digital reputation.",
      details: [
        "Sentiment analysis & monitoring",
        "Crisis management",
        "Review & rating optimization",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Press Release Writing",
      description: "Professional press releases that capture media attention.",
      details: [
        "Media-friendly formatting",
        "Compelling narrative hook",
        "SEO-optimized content",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Email & Newsletter Copywriting",
      description: "Persuasive copy that nurtures leads and encourages action.",
      details: [
        "Cold Outreach Emails",
        "Drip Campaigns & Product Launches",
        "CTR & Open Rate Optimization",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "eBooks, Whitepapers & Lead Magnets",
      description: "In-depth, value-driven content for lead generation.",
      details: [
        "Design + Copy + CTA Integration",
        "Gated Content Strategy",
        "Multi-Format (PDF, Web, Email)",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Content Pack",
      price: "",
      features: [
        "4 Blog Posts",
        "2 Social Media Captions Weekly",
        "Basic SEO Optimization",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Content Pack",
      price: "",
      features: [
        "8 Blog Posts + 2 Video Scripts",
        "3 Social Posts/Week",
        "Email Newsletter Copy",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Content Suite",
      price: "",
      features: [
        "15+ Content Assets/Month",
        "Strategy + Distribution",
        "Lead Magnet Creation",
        "Monthly Analytics Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Why is content marketing important?",
      answer:
        "Content builds trust with your audience, drives SEO performance, and helps convert visitors into customers.",
    },
    {
      question: "How do you decide what content to create?",
      answer:
        "We analyze your goals, audience, and competitors to create a content plan that matches your objectives.",
    },
    {
      question: "Do you provide visual design for content?",
      answer:
        "Yes. We include graphic design, layout, and formatting for social content, lead magnets, and more.",
    },
    {
      question: "Can you help with content distribution?",
      answer:
        "Absolutely. We can publish, schedule, and promote content across your blog, social media, and email.",
    },
    {
      question: "Is content optimized for SEO?",
      answer:
        "Yes. Every blog or article we write is optimized for target keywords, meta tags, readability, and internal linking.",
    },
    {
      question: "Can I review and approve content before publishing?",
      answer:
        "Yes. Youll have full visibility and approval control before anything goes live.",
    },
  ],
};
export const SocialMediaMarketingPageDetails = {
  SeoName: {
    seotitle: "SocialMediaMarketingPageDetailsseo",
  },
  title: "Social Media & Creative Management",
  subtitle:
    "Enhance your brand presence with creative content, strategic management, and organic growth on all major social platforms.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Be Where Your Customers Are",
    heading: "Social Media Campaigns That Convert & Engage",
    description:
      "Cyber Space Digital helps your brand grow on platforms like Instagram, Facebook, LinkedIn, Twitter, and YouTube through content strategy, ad campaigns, influencer collaborations, and more.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Social Media Management",
      description:
        "Professional management for Instagram, Facebook, YouTube, and LinkedIn.",
      details: [
        "Consistent posting and activity",
        "Engagement with followers",
        "Platform-specific optimization",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Poster Designing (Static & Motion)",
      description: "High-quality visual content tailored for your brand.",
      details: [
        "Eye-catching static designs",
        "Engaging motion graphics",
        "Brand-aligned aesthetics",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Reel Creation & Editing",
      description: "Trending short-form video content to boost your reach.",
      details: [
        "Concept development",
        "Professional editing",
        "Viral engagement strategies",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Content Strategy & Calendar Planning",
      description: "Strategic planning for consistent and impactful content.",
      details: [
        "Content bucket development",
        "Monthly content calendars",
        "Strategic posting schedules",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Page Growth Strategy",
      description: "Data-driven techniques to scale your social presence.",
      details: [
        "Audience analysis",
        "Organic reach optimization",
        "Growth hacking techniques",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Community Management",
      description: "Nurturing and growing your online community.",
      details: [
        "Moderating discussions",
        "Responding to comments and queries",
        "Building brand loyalty",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Social Pack",
      price: "",
      features: [
        "2 Platforms (IG + FB)",
        "8 Posts/Month",
        "Basic Strategy & Hashtags",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Social Plan",
      price: "",
      features: [
        "3 Platforms (IG, FB, LinkedIn)",
        "15+ Content Pieces",
        "1 Reel/Week + Ad Setup",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Complete Brand Suite",
      price: "",
      features: [
        "Full Channel Management",
        "Influencer Collab Support",
        "Monthly Analytics + Strategy Call",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Which platforms do you manage?",
      answer:
        "We manage Instagram, Facebook, LinkedIn, YouTube, Twitter, and Pinterest based on your goals.",
    },
    {
      question: "Do you create both content and run ads?",
      answer:
        "Yes. We create content (visuals, captions, reels) and run paid ad campaigns with full reporting.",
    },
    {
      question: "How often will you post for my brand?",
      answer:
        "Posting frequency depends on the selected plan”typically 2“4 times per week with story content too.",
    },
    {
      question: "Will I be able to approve content before publishing?",
      answer:
        "Yes. You will receive a monthly content calendar in advance for review and approval.",
    },
    {
      question: "Can you help with Instagram Reels?",
      answer:
        "Absolutely. We handle reel scripting, editing, thumbnail design, and optimization.",
    },
    {
      question: "Do you offer customer engagement?",
      answer:
        "Yes. We can help manage DMs, reply to comments, and keep engagement active for your community.",
    },
  ],
};
export const EmailMarketingPageDetails = {
  SeoName: {
    seotitle: "EmailMarketingPageDetailsseo",
  },
  title: "Email Marketing Services",
  subtitle:
    "Drive engagement, nurture leads, and boost conversions with targeted, well-designed email campaigns.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Your Direct Line to Customers",
    heading: "Email Campaigns That Build Loyalty & Sales",
    description:
      "Cyber Space Digital helps you design, automate, and optimize email campaigns that speak to your audience and deliver measurable ROI. From welcome flows to promotional blasts, we cover it all.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Email Strategy & Segmentation",
      description: "Tailored strategy based on audience behavior and goals.",
      details: [
        "Subscriber Segmentation",
        "Personalization Tactics",
        "Content Planning",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign Design & Content",
      description: "Visually appealing, mobile-responsive email templates.",
      details: [
        "Branded Templates",
        "Copywriting & CTAs",
        "Responsive Layouts",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Automated Email Workflows",
      description: "Trigger-based journeys to nurture leads and customers.",
      details: [
        "Welcome Series",
        "Abandoned Cart Recovery",
        "Post-Purchase Follow-ups",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Promotional & Seasonal Campaigns",
      description: "Boost sales during key moments and events.",
      details: [
        "Product Launch Emails",
        "Festive Offers & Flash Sales",
        "Re-Engagement Campaigns",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Email Deliverability Optimization",
      description: "Maximize inbox placement and open rates.",
      details: [
        "Spam Score Checks",
        "Sender Reputation Monitoring",
        "DKIM, SPF, DMARC Setup",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Analytics & Performance Reporting",
      description: "Track and improve campaign success.",
      details: [
        "Open & Click Rates",
        "A/B Testing Reports",
        "Revenue Attribution",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Email Pack",
      price: "",
      features: [
        "Up to 3 Campaigns/Month",
        "Basic Template Setup",
        "Open & Click Rate Reports",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Automation + Growth Plan",
      price: "",
      features: [
        "Up to 6 Campaigns + Automations",
        "Custom Templates + Segments",
        "A/B Testing + CRM Integration",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Suite",
      price: "",
      features: [
        "Unlimited Campaigns",
        "Multi-Language Templates",
        "Advanced Reporting + Team Training",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What email platforms do you support?",
      answer:
        "We work with Mailchimp, Sendinblue, Zoho Mail, Klaviyo, MailerLite, and custom SMTP setups.",
    },
    {
      question: "Can you help grow my email list?",
      answer:
        "Yes, we implement list-building strategies such as landing pages, popups, lead magnets, and integrations.",
    },
    {
      question: "Do you write the email content too?",
      answer:
        "Absolutely. Our copywriters craft compelling subject lines, body copy, and call-to-actions tailored to your audience.",
    },
    {
      question: "Will the emails be mobile-friendly?",
      answer:
        "Yes. All designs are responsive and tested for compatibility across devices and email clients.",
    },
    {
      question: "Can I automate emails for customer behavior?",
      answer:
        "Yes. We set up automated workflows triggered by signups, purchases, inactivity, and more.",
    },
    {
      question: "How do you measure email performance?",
      answer:
        "We track open rates, click-throughs, bounce rates, unsubscribes, conversions, and revenue attribution.",
    },
  ],
};
export const PayPerClickAdvertisingPageDetails = {
  SeoName: {
    seotitle: "PayPerClickAdvertisingPageDetailsseo",
  },
  title: "Pay-Per-Click (PPC) Advertising Services",
  subtitle:
    "Maximize your visibility and ROI with precisely targeted, conversion-focused paid ads.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Instant Visibility, Measurable Results",
    heading: "Strategic PPC Campaigns That Drive Quality Traffic",
    description:
      "Cyber Space Digital crafts and manages high-performance PPC campaigns across Google, Meta, LinkedIn, and more ” designed to deliver leads, conversions, and real business outcomes.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Google Search & Display Ads",
      description: "Run keyword and banner ads across Google network.",
      details: [
        "Keyword Research & Match Types",
        "Ad Copy Creation",
        "Geo & Device Targeting",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Social Media Ads (Meta, Instagram, LinkedIn)",
      description: "Paid ads on major platforms to reach targeted audiences.",
      details: [
        "Audience Segmentation",
        "Creative Design & Messaging",
        "Lead Generation & Retargeting",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Landing Page Optimization",
      description: "Custom pages that convert clicks into actions.",
      details: ["Design & Copywriting", "Form Integrations", "A/B Testing"],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign Setup & Management",
      description: "End-to-end campaign creation and optimization.",
      details: [
        "Campaign Structuring",
        "Budget Allocation",
        "Performance Tracking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Retargeting & Remarketing Ads",
      description: "Bring back lost visitors and abandoned carts.",
      details: [
        "Dynamic Retargeting Setup",
        "Custom Audience Building",
        "Conversion Funnel Mapping",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Ad Spend ROI Analysis & Reporting",
      description: "Track ROI and optimize with data.",
      details: [
        "Cost Per Click (CPC) & Acquisition (CPA)",
        "Click-Through & Conversion Rate Reports",
        "Real-Time Analytics Dashboards",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter PPC Plan",
      price: "",
      features: [
        "Google Search or Facebook Ads",
        "Ad Copy + Setup",
        "Weekly Performance Report",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Advertising Plan",
      price: "",
      features: [
        "Google + Social Ads Combo",
        "Retargeting + Landing Page Support",
        "Conversion Tracking + A/B Testing",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise PPC Suite",
      price: "",
      features: [
        "Multi-Platform Campaigns",
        "Advanced Funnel + Budget Strategy",
        "Real-Time Reports + Dedicated Manager",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Which platforms do you run PPC ads on?",
      answer:
        "We run campaigns on Google Search & Display, YouTube, Facebook, Instagram, LinkedIn, Twitter, and others based on your goals.",
    },
    {
      question: "Do you help with ad creatives and copywriting?",
      answer:
        "Yes. We create compelling ad copy, visuals, and CTAs tailored to each platform and audience segment.",
    },
    {
      question: "Can I track how much each lead costs?",
      answer:
        "Absolutely. We provide detailed ROI reporting including CPC, CPA, impressions, CTR, and conversion tracking.",
    },
    {
      question: "How much should I spend on PPC?",
      answer:
        "We help define budgets based on your industry, goals, and keyword competition ” and optimize spend for best results.",
    },
    {
      question: "Do you set up remarketing campaigns?",
      answer:
        "Yes. We build custom remarketing lists and run dynamic retargeting ads to re-engage past visitors.",
    },
    {
      question: "Can you manage both Google and Meta ads together?",
      answer:
        "Yes. Our team can manage integrated campaigns across Google Ads, Meta Ads, and other channels for a unified strategy.",
    },
  ],
};
export const AffiliateMarketingPageDetails = {
  SeoName: {
    seotitle: "AffiliateMarketingPageDetailsseo",
  },
  title: "Affiliate Marketing Services",
  subtitle:
    "Leverage a powerful network of publishers and influencers to drive results through performance-based marketing.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Grow Through Strategic Partnerships",
    heading: "Performance-Driven Affiliate Marketing Solutions",
    description:
      "Cyber Space Digital helps you build, manage, and scale affiliate programs that generate measurable leads and sales while maintaining full control over costs and brand representation.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Affiliate Program Setup",
      description: "Design and launch a scalable affiliate system.",
      details: [
        "Commission Structure Planning",
        "Terms, Policies, and Guidelines",
        "Affiliate Signup and Tracking Setup",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Affiliate Network Management",
      description: "Connect with trusted affiliate platforms and networks.",
      details: [
        "Integration with ShareASale, CJ, Impact, etc.",
        "Partner Vetting & Onboarding",
        "Marketplace Listing & Outreach",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Tracking & Reporting Infrastructure",
      description: "Monitor conversions, clicks, and partner performance.",
      details: [
        "UTM + Pixel-Based Tracking",
        "Real-Time Analytics Dashboard",
        "Commission Reconciliation & Fraud Detection",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Publisher & Influencer Recruitment",
      description: "Grow your affiliate network with niche-specific partners.",
      details: [
        "Content & Coupon Affiliates",
        "Bloggers & YouTubers",
        "B2B Referrals & Micro-Influencers",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign & Offer Management",
      description:
        "Promote seasonal deals and product launches via affiliates.",
      details: [
        "Limited-Time Offers & Discounts",
        "Referral Bonuses",
        "Cross-Promotion Campaigns",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Affiliate Program Optimization",
      description: "Maximize ROI by improving partner performance.",
      details: [
        "Commission Tiering",
        "Inactive Affiliate Cleanup",
        "Performance-Based Rewards",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Affiliate Setup",
      price: "",
      features: [
        "Affiliate Program Design",
        "Commission Model Setup",
        "Signup Page + Basic Tracking",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Affiliate Management",
      price: "",
      features: [
        "Platform Integration",
        "Partner Recruitment",
        "Performance Reporting",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Affiliate Suite",
      price: "",
      features: [
        "Full Funnel Attribution",
        "Custom Dashboards + Fraud Control",
        "Dedicated Program Manager",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What is affiliate marketing and how does it work?",
      answer:
        "Affiliate marketing is a performance-based channel where you reward third-party partners (affiliates) for driving traffic or sales to your website.",
    },
    {
      question: "Can you help us set up our own affiliate program?",
      answer:
        "Yes. We build custom affiliate programs from scratch or integrate with networks like CJ, ShareASale, or Impact.",
    },
    {
      question: "How are affiliates tracked?",
      answer:
        "We use tracking platforms, cookies, UTM parameters, and pixels to ensure accurate lead/sale attribution per affiliate.",
    },
    {
      question: "Do you also handle affiliate payouts?",
      answer:
        "We can help you set up automated or manual payout systems, and provide support for reconciliation and fraud monitoring.",
    },
    {
      question: "What types of affiliates can you recruit?",
      answer:
        "We recruit coupon sites, content creators, niche bloggers, review platforms, influencers, and more ” based on your product niche.",
    },
    {
      question: "Is affiliate marketing cost-effective?",
      answer:
        "Yes. Since you only pay for actual performance (clicks, leads, or sales), affiliate marketing is often highly ROI-positive.",
    },
  ],
};
export const AnalyticsAndDataAnalysisPageDetails = {
  SeoName: {
    seotitle: "AnalyticsAndDataAnalysisPageDetailsseo",
  },
  title: "Analytics & Data Analysis Services",
  subtitle:
    "Turn data into decisions with our expert marketing analytics, dashboards, and performance insights.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Data-Driven Marketing Intelligence",
    heading: "Measure, Understand, and Optimize Your Digital Performance",
    description:
      "Cyber Space Digital helps you collect, analyze, and visualize marketing data across platforms. Make smarter decisions backed by real-time insights, user behavior tracking, and ROI analysis.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Web & App Analytics Setup",
      description: "Track user behavior across websites and mobile apps.",
      details: [
        "Google Analytics (GA4) & Firebase Integration",
        "User Journey, Funnels, & Events",
        "Cross-Device Tracking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Marketing Dashboard Development",
      description: "Centralize KPIs from all channels into one view.",
      details: [
        "Custom Reports with Google Looker Studio",
        "Real-Time Campaign Metrics",
        "Data from Ads, CRM, Social, and Email",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Tag Management & Conversion Tracking",
      description: "Track conversions, goals, and custom events.",
      details: [
        "Google Tag Manager Setup",
        "UTM Parameters & Attribution Modeling",
        "E-Commerce & Lead Form Tracking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Audience Segmentation & Cohort Analysis",
      description: "Understand your users by demographics and behavior.",
      details: [
        "First-Time vs Returning Visitors",
        "Geo, Device, and Interest-Based Breakdown",
        "High-Intent & High-LTV Segments",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Campaign ROI Analysis",
      description: "Know whats working, and where to invest more.",
      details: [
        "Multi-Channel Attribution",
        "Revenue vs Spend Reports",
        "Cost Per Lead/Sale Tracking",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Data-Backed Strategy Consulting",
      description: "Use insights to guide content, ads, and UX strategy.",
      details: [
        "User Drop-Off & Retention Insights",
        "Conversion Funnel Optimization",
        "Strategy Roadmap Based on Data",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Analytics Starter Pack",
      price: "",
      features: [
        "GA4 + Tag Manager Setup",
        "UTM Structure & Goal Tracking",
        "Basic Traffic Source Analysis",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Pro Dashboard Suite",
      price: "",
      features: [
        "Cross-Channel Dashboard",
        "E-Commerce or Lead Funnel Reports",
        "Weekly Performance Reviews",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Data Intelligence",
      price: "",
      features: [
        "BI Integrations (Looker, Power BI)",
        "Advanced Attribution Models",
        "Dedicated Data Analyst Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Why is marketing analytics important?",
      answer:
        "It helps you understand what's working and whats not, so you can allocate your budget more effectively and improve results.",
    },
    {
      question: "Do you help with Google Analytics 4 migration?",
      answer:
        "Yes. We handle GA4 setup, property linking, custom events, and historical data tracking from UA.",
    },
    {
      question: "Can I track both website and app users?",
      answer:
        "Absolutely. We use tools like GA4 and Firebase for seamless web + app tracking and unified analytics.",
    },
    {
      question: "Will I get a custom dashboard for my data?",
      answer:
        "Yes. We create visual dashboards with Google Looker Studio, Power BI, or your preferred platform.",
    },
    {
      question: "Do you offer consultation based on the data?",
      answer:
        "Yes. We dont just track data ” we help interpret it and guide your growth strategy accordingly.",
    },
    {
      question: "How secure is the data you work with?",
      answer:
        "All analytics are implemented using best practices with full transparency, client access, and secure connections only.",
    },
  ],
};
export const ConversionRateOptimizationPageDetails = {
  SeoName: {
    seotitle: "ConversionRateOptimizationPageDetailsseo",
  },
  title: "Conversion Rate Optimization (CRO) Services",
  subtitle:
    "Maximize every visitors potential with our data-driven CRO strategies designed to boost leads, sales, and ROI.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Turn Traffic into Revenue",
    heading: "Data-Driven Conversion Strategies That Work",
    description:
      "Cyber Space Digital identifies friction points and optimizes user experience to help you convert more visitors into customers. Our CRO experts use analytics, heatmaps, and A/B testing to boost your conversion rates.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Conversion Funnel Audit",
      description: "Analyze every step of your funnel to detect drop-offs.",
      details: [
        "Landing Page Analysis",
        "Form Optimization",
        "Checkout Flow Review",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "A/B Testing & Multivariate Testing",
      description: "Test variants to find high-performing versions.",
      details: [
        "Headline & CTA Variations",
        "Form Field Testing",
        "UI/UX Elements Split Testing",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Heatmaps & Behavior Analytics",
      description: "See how users navigate your site or app.",
      details: [
        "Mouse Movement & Click Tracking",
        "Scroll Depth Reports",
        "Session Recordings",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Form & Checkout Optimization",
      description: "Reduce abandonment and friction during signup or purchase.",
      details: [
        "Smart Form Validation",
        "Progressive Form Loading",
        "Mobile-First Checkout UI",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Conversion Copywriting",
      description: "Craft words that persuade and sell.",
      details: [
        "Action-Oriented CTA Texts",
        "Landing Page Copy Optimization",
        "Value Proposition Refinement",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "CRO Reporting & Strategy",
      description: "Track improvements and define clear goals.",
      details: [
        "Conversion Benchmarks & KPIs",
        "Ongoing Optimization Plan",
        "Weekly Test Reports",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Landing Page Boost",
      price: "",
      features: ["Funnel Audit", "CTA & Copy Suggestions", "Heatmap Snapshot"],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Optimization Plan",
      price: "",
      features: [
        "A/B Testing Setup",
        "Form + Checkout Optimization",
        "Conversion Dashboard",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "CRO Enterprise Suite",
      price: "",
      features: [
        "Full Site Testing Plan",
        "Behavior Analytics Tools Integration",
        "Weekly Strategy + Copy Support",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What is Conversion Rate Optimization?",
      answer:
        "CRO is the process of increasing the percentage of website visitors who complete a desired action like filling a form, purchasing, or signing up.",
    },
    {
      question: "Do I need a lot of traffic to do CRO?",
      answer:
        "No. Even small websites benefit from CRO by making key improvements based on user behavior and micro-conversions.",
    },
    {
      question: "How long does it take to see results?",
      answer:
        "Results vary, but many clients see measurable improvements in 2“4 weeks after the first set of optimizations or tests.",
    },
    {
      question: "What tools do you use for heatmaps or testing?",
      answer:
        "We use tools like Hotjar, Microsoft Clarity, Google Optimize, VWO, and others based on project needs.",
    },
    {
      question: "Is CRO only for e-commerce sites?",
      answer:
        "No. CRO benefits all websites ” from SaaS platforms and service providers to blogs and B2B portals.",
    },
    {
      question: "Can you help with content and design improvements?",
      answer:
        "Yes. We support both copywriting and design refinement to improve overall persuasion and clarity on your site.",
    },
  ],
};
export const MobileMarketingPageDetails = {
  SeoName: {
    seotitle: "MobileMarketingPageDetailsseo",
  },
  title: "Mobile Marketing Services",
  subtitle:
    "Engage your audience directly on their smartphones with mobile-optimized strategies that drive app downloads, retention, and conversions.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Reach Customers on the Go",
    heading: "Smart Mobile Marketing Campaigns for Smart Devices",
    description:
      "At Cyber Space Digital, we craft personalized mobile marketing strategies that leverage SMS, push notifications, app store optimization, mobile search, and in-app advertising to keep your brand in front of users”anytime, anywhere.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "App Store Optimization (ASO)",
      description: "Improve your apps visibility and downloads organically.",
      details: [
        "Keyword Optimization",
        "Creative Asset Optimization",
        "Rating & Review Management",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Push Notification Campaigns",
      description: "Send targeted updates to re-engage users.",
      details: [
        "Behavior-Based Triggers",
        "Time-Zone Based Delivery",
        "Cart Abandonment & Retention Flows",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "SMS & WhatsApp Marketing",
      description: "Reach users instantly with offers, alerts, and support.",
      details: [
        "Transactional + Promotional Messaging",
        "Bulk SMS Integration",
        "Two-Way WhatsApp Campaigns",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "In-App Advertising",
      description: "Advertise inside other popular apps.",
      details: [
        "Banner & Interstitial Ads",
        "Video & Rewarded Ads",
        "Hyperlocal & Behavioral Targeting",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Mobile Search & Display Ads",
      description: "Capture mobile traffic through search and display.",
      details: [
        "Mobile-Specific Ad Creatives",
        "Call Extensions & Click-to-Call",
        "Responsive Search Ads",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Mobile App Retargeting",
      description: "Win back inactive users with retargeting strategies.",
      details: [
        "Dynamic Ads Based on In-App Behavior",
        "Cross-Platform Retargeting",
        "User Journey Optimization",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Mobile Campaign",
      price: "",
      features: [
        "SMS Blast (up to 5,000 users)",
        "Basic Push Notification Setup",
        "Basic ASO Audit",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Engagement Plan",
      price: "",
      features: [
        "In-App + Mobile Search Ads",
        "Push Notification Automation",
        "WhatsApp Broadcast Campaigns",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Mobile Mastery Suite",
      price: "",
      features: [
        "App Retargeting & Analytics",
        "Full ASO Strategy",
        "Dedicated Mobile Ads Manager",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What is mobile marketing?",
      answer:
        "Mobile marketing refers to promotional activities designed for smartphones, tablets, and mobile apps through SMS, push notifications, in-app ads, and mobile search.",
    },
    {
      question: "Is mobile marketing suitable for all businesses?",
      answer:
        "Yes. Any business with mobile users can benefit, especially e-commerce, service apps, local businesses, and D2C brands.",
    },
    {
      question: "Do you provide bulk SMS and WhatsApp marketing?",
      answer:
        "Yes. We provide both promotional and transactional SMS & WhatsApp messaging with detailed reports and delivery tracking.",
    },
    {
      question: "What is App Store Optimization (ASO)?",
      answer:
        "ASO is the process of optimizing your apps listing on Google Play or App Store to improve visibility, downloads, and conversions.",
    },
    {
      question: "How do you measure mobile campaign performance?",
      answer:
        "We track key metrics such as installs, click-through rate, open rate, retention rate, and cost per conversion to measure success.",
    },
    {
      question: "Do you support both Android and iOS?",
      answer:
        "Yes. Our strategies are tailored to both platforms for maximum reach and impact.",
    },
  ],
};
export const VideoMarketingPageDetails = {
  SeoName: {
    seotitle: "VideoMarketingPageDetailsseo",
  },
  title: "Video Marketing Services",
  subtitle:
    "Harness the power of visual storytelling to captivate your audience, build trust, and drive conversions across all digital platforms.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Tell Your Brand Story Visually",
    heading: "Professional Video Marketing Solutions That Convert",
    description:
      "Cyber Space Digital creates engaging video content for YouTube, social media, websites, and ads to help businesses stand out, build emotional connections, and improve online visibility.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Explainer & Promo Videos",
      description: "Simplify complex ideas with clear, animated videos.",
      details: [
        "2D/3D Animation Options",
        "Script Writing & Voiceovers",
        "Brand-Focused Storytelling",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Social Media Video Ads",
      description: "Grab attention with thumb-stopping video content.",
      details: [
        "Instagram Reels & TikTok Videos",
        "Facebook & YouTube Ad Creatives",
        "Optimized for Engagement & Shares",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Corporate Videos",
      description: "Professional brand videos that reflect your identity.",
      details: [
        "Office Shoots & Interviews",
        "Culture & Team Highlights",
        "HD & 4K Production Quality",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Product Demos & Reviews",
      description: "Showcase your product features and benefits visually.",
      details: [
        "Unboxing & Use-Case Videos",
        "Voice-Over or On-Camera Delivery",
        "Custom Motion Graphics",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Video SEO & YouTube Optimization",
      description: "Rank higher and increase views on your videos.",
      details: [
        "Keyword-Rich Titles & Descriptions",
        "Thumbnail Design & Metadata Optimization",
        "Playlist & Channel Strategy",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Video Ad Campaign Management",
      description: "Drive leads through targeted video advertising.",
      details: [
        "YouTube TrueView & In-Stream Ads",
        "Audience Retargeting",
        "Budget & Performance Optimization",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Video Pack",
      price: "",
      features: [
        "1 Social Media Promo Video",
        "Basic Editing & Branding",
        "Up to 60 Seconds Duration",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Video Strategy",
      price: "",
      features: [
        "2“3 High-Quality Videos",
        "YouTube Channel Setup & SEO",
        "Ad-Ready Formats Included",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Full Video Marketing Suite",
      price: "",
      features: [
        "Script, Shoot & Edit Package",
        "Motion Graphics + Voice Over",
        "YouTube & Video Ad Campaigns",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What types of videos do you create?",
      answer:
        "We create explainer videos, product demos, promo videos, YouTube content, social media reels, and corporate videos tailored to your goals.",
    },
    {
      question: "Can you help us with video ads?",
      answer:
        "Yes. We not only create ad-friendly videos but also run and optimize YouTube and social media ad campaigns for maximum ROI.",
    },
    {
      question: "Do you offer scripting and voiceovers?",
      answer:
        "Absolutely. We provide scriptwriting, voice-over recording, and background music for all video types.",
    },
    {
      question: "How long does a typical video project take?",
      answer:
        "Depending on complexity, a video project may take anywhere from 5 to 15 days including edits and approvals.",
    },
    {
      question: "Can I use the videos on my website and social media?",
      answer:
        "Yes. All videos are delivered in formats suitable for web, mobile, YouTube, and social media platforms.",
    },
    {
      question: "Do you support 2D and 3D animation?",
      answer:
        "Yes, we offer both 2D and 3D animation options based on your business needs and project type.",
    },
  ],
};
export const LocalSeoAndMarketingPageDetails = {
  SeoName: {
    seotitle: "LocalSeoAndMarketingPageDetailsseo",
  },
  title: "Local SEO & Marketing Services",
  subtitle:
    "Boost your visibility in local search results and attract more nearby customers with our targeted local marketing strategies.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Be Found by Customers Near You",
    heading: "Local SEO Optimization & Hyperlocal Marketing",
    description:
      "Cyber Space Digital helps your business rank higher in Google Maps and local search with verified listings, customer reviews, location pages, and community engagement strategies.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Google Business Profile Optimization",
      description: "Stand out in Maps & local searches.",
      details: [
        "Profile Setup or Audit",
        "Service Areas & Hours",
        "Geo-Tagged Photos & Posts",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Local Citation Building",
      description: "Improve your online presence across local directories.",
      details: [
        "NAP Consistency (Name, Address, Phone)",
        "Top Business Listings (Justdial, Sulekha, Yelp)",
        "Industry-Specific Directory Submissions",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Location-Based SEO",
      description: "Rank higher for local keywords.",
      details: [
        "Geo-Targeted Keyword Research",
        "City & Area Landing Pages",
        "Localized Blog & Content Strategy",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Customer Review Generation",
      description: "Build trust with authentic local reviews.",
      details: [
        "Review Request Campaigns",
        "Reputation Monitoring & Alerts",
        "Respond to Negative Reviews",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Local Ad Campaigns",
      description: "Reach local customers via search and maps ads.",
      details: [
        "Google Local Services Ads",
        "Location Extensions in Search Ads",
        "Hyperlocal Geo-Fencing Ads",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Local Analytics & Insights",
      description: "Track your performance in your target region.",
      details: [
        "Map Impressions & Clicks",
        "Call & Direction Tracking",
        "Competitor Benchmarking",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Local Presence",
      price: "",
      features: [
        "Google Profile Setup",
        "NAP Listings (5“10)",
        "1 Location Page",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Local SEO Plan",
      price: "",
      features: [
        "Profile Optimization + Posts",
        "Local Keywords & Blog",
        "10“20 Directory Listings",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Local Domination",
      price: "",
      features: [
        "Multi-Location Strategy",
        "Review & Reputation Management",
        "Google Ads for Local Leads",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What is Local SEO and why is it important?",
      answer:
        "Local SEO helps your business appear in search results when nearby customers search for your services. It boosts visibility, foot traffic, and local leads.",
    },
    {
      question: "Can you help me appear on Google Maps?",
      answer:
        "Yes. We optimize your Google Business Profile for Maps visibility, with categories, images, posts, and service coverage updates.",
    },
    {
      question: "How do reviews affect my local ranking?",
      answer:
        "Customer reviews significantly impact your rankings and trust level. We help you gather positive reviews and manage reputation actively.",
    },
    {
      question: "What are citations and why do they matter?",
      answer:
        "Citations are mentions of your business details across the web. Consistent citations strengthen local authority and SEO rankings.",
    },
    {
      question: "Will I get reports on my local performance?",
      answer:
        "Yes. We provide insights like map clicks, direction requests, call volume, and how users find your business locally.",
    },
    {
      question: "Do you support businesses with multiple locations?",
      answer:
        "Absolutely. We create a local strategy tailored for each branch with location pages, listings, and geo-targeted content.",
    },
  ],
};
export const EcommerceMarketingPageDetails = {
  SeoName: {
    seotitle: "EcommerceMarketingPageDetailsseo",
  },
  title: "DefaultIcon Marketing Services",
  subtitle:
    "Grow your online store traffic, improve conversions, and increase repeat sales with our full-funnel DefaultIcon marketing solutions.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Drive Sales, Not Just Traffic",
    heading: "End-to-End Digital Marketing for Online Stores",
    description:
      "Cyber Space Digital helps DefaultIcon brands grow through proven SEO, PPC, email flows, automation, and more. Whether you sell fashion, electronics, or groceries ” we scale your store the smart way.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "DefaultIcon SEO",
      description: "Improve your product rankings & category visibility.",
      details: [
        "Product Schema & Structured Data",
        "Optimized Category & Product Descriptions",
        "Technical SEO for Store Speed & Indexing",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Paid Advertising for Products",
      description: "Boost conversions with smart paid campaigns.",
      details: [
        "Google Shopping Ads",
        "Dynamic Retargeting on Meta & Instagram",
        "Seasonal Sale Campaigns",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Email & SMS Marketing",
      description: "Nurture your customers with personalized messaging.",
      details: [
        "Abandoned Cart Recovery",
        "Welcome & Win-Back Flows",
        "Flash Sale Announcements",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Conversion Rate Optimization",
      description: "Turn visitors into buyers with better UX.",
      details: [
        "A/B Testing of Product Pages",
        "Checkout Funnel Optimization",
        "Trust Signals & Reviews",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Marketplace Management",
      description: "Sell better on Amazon, Flipkart & other platforms.",
      details: [
        "Product Listing Optimization",
        "Ad Management & Bidding",
        "Ratings & Feedback Strategy",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Analytics & Reporting",
      description: "Track performance and revenue sources.",
      details: [
        "Sales Funnel Dashboards",
        "Multi-Channel Attribution",
        "Customer Lifetime Value Metrics",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Basic Store Booster",
      price: "",
      features: [
        "Product SEO Setup",
        "Cart Recovery Emails",
        "Google Shopping Setup",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth DefaultIcon Plan",
      price: "",
      features: [
        "SEO + Meta Ads",
        "Conversion Optimization",
        "Weekly Campaigns",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Scale Suite",
      price: "",
      features: [
        "Marketplace + Website Ads",
        "Automated Workflows",
        "Dedicated Account Manager",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Do you work with Shopify or WooCommerce stores?",
      answer:
        "Yes. We work with Shopify, WooCommerce, Magento, BigCommerce, and other platforms with full integration capabilities.",
    },
    {
      question: "Can you run paid ads for my product catalog?",
      answer:
        "Absolutely. We manage Google Shopping Ads, Facebook dynamic product ads, and offer conversion-focused ad strategies.",
    },
    {
      question: "How can you reduce abandoned carts?",
      answer:
        "Through automated email & SMS recovery flows, personalized discount triggers, and optimization of checkout UX.",
    },
    {
      question: "Will I get reports on sales performance?",
      answer:
        "Yes. We provide clear analytics dashboards, traffic vs. conversion insights, and campaign-wise revenue tracking.",
    },
    {
      question: "Can you help me sell on Amazon or Flipkart?",
      answer:
        "Yes. We assist with product listing optimization, ads, seller ranking strategy, and ratings improvement.",
    },
    {
      question: "Do you offer full store management?",
      answer:
        "While we dont fulfill orders, we offer end-to-end marketing, catalog management guidance, and growth consulting.",
    },
  ],
};
export const MarketingAutomationPageDetails = {
  SeoName: {
    seotitle: "MarketingAutomationPageDetailsseo",
  },
  title: "Code Business (Technology & Growth Systems)",
  subtitle:
    "Scale your brand with advanced SEO, AI automation, and high-performance growth systems.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Smarter Marketing, Better ROI",
    heading: "Automate Customer Journeys & Nurture Leads Efficiently",
    description:
      "Cyber Space Digital helps businesses streamline their marketing workflows using automation tools like HubSpot, Mailchimp, ActiveCampaign, and more. From lead nurturing to customer retention ” automate it all with precision.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Search Engine Optimization (SEO)",
      description: "Organic growth systems to dominate search results.",
      details: [
        "On-Page & Technical SEO",
        "Backlink Building Strategy",
        "Local SEO Optimization",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "AI Automation Systems",
      description: "Automate repetitive tasks with intelligent AI workflows.",
      details: [
        "Workflow automation",
        "AI-driven content systems",
        "Business process optimization",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Chatbot Integration",
      description: "24/7 customer support and lead capture via smart bots.",
      details: [
        "WhatsApp & Web chatbots",
        "AI-powered responses",
        "Seamless human handover",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "CRM & Sales Pipelines",
      description: "Organize leads and automate sales for better conversion.",
      details: [
        "CRM Setup & Integration",
        "Sales Pipeline design",
        "Lead scoring & automation",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Funnel Design & Tracking",
      description: "High-converting sales funnels with end-to-end tracking.",
      details: [
        "Landing page optimization",
        "Conversion tracking setup",
        "Multi-step funnel design",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Lead Automation Systems",
      description: "Scale your lead generation with automated systems.",
      details: [
        "Lead capture automation",
        "Nurturing workflows",
        "ROI tracking & attribution",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Automation Kit",
      price: "",
      features: [
        "Email Flows Setup",
        "Lead Form to Email Journey",
        "Cart Recovery Workflow",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Growth Automation Suite",
      price: "",
      features: [
        "CRM Integration",
        "Multi-Step Nurturing",
        "Analytics Dashboard",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Enterprise Automation Engine",
      price: "",
      features: [
        "Custom Platform Integration",
        "Omnichannel Journeys",
        "Dedicated Workflow Specialist",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "Which tools do you use for marketing automation?",
      answer:
        "We work with leading platforms like HubSpot, Mailchimp, ActiveCampaign, Klaviyo, and Zoho ” based on your business needs.",
    },
    {
      question: "Can you set up cart recovery emails for my store?",
      answer:
        "Yes. We set up automated cart abandonment flows for Shopify, WooCommerce, and custom DefaultIcon sites.",
    },
    {
      question: "Is multi-channel automation possible?",
      answer:
        "Absolutely. We create journeys across email, SMS, WhatsApp, and push notifications for complete engagement.",
    },
    {
      question: "Will I be able to track the effectiveness of automation?",
      answer:
        "Yes. We provide analytics dashboards showing open/click rates, conversion tracking, and funnel insights.",
    },
    {
      question: "Can you integrate automation with my CRM?",
      answer:
        "Yes. We integrate with CRMs like Zoho, Salesforce, HubSpot, or custom systems to sync data and trigger flows.",
    },
    {
      question: "Do you offer full service setup or only consulting?",
      answer:
        "We offer both ” hands-on implementation as well as consulting and training based on your needs.",
    },
  ],
};
export const RemarketingRetargetingPageDetails = {
  SeoName: {
    seotitle: "RemarketingRetargetingPageDetailsseo",
  },
  title: "Remarketing & Retargeting Services",
  subtitle:
    "Re-engage lost visitors and turn window shoppers into paying customers with strategic ad campaigns.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Win Back Customers, Maximize ROI",
    heading: "Target High-Intent Audiences with Smart Remarketing",
    description:
      "Cyber Space Digital helps you set up and run data-driven remarketing and retargeting campaigns on platforms like Google, Facebook, Instagram, and more ” ensuring your brand stays top-of-mind and brings users back to convert.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Google Ads Remarketing",
      description: "Reconnect with users via display and search ads.",
      details: [
        "Tag-Based Audiences for Website Visitors",
        "Dynamic Product Remarketing",
        "YouTube Video Remarketing",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Facebook & Instagram Retargeting",
      description: "Engage users where they scroll daily.",
      details: [
        "Custom & Lookalike Audience Campaigns",
        "Retarget Product Viewers & Abandoned Carts",
        "Carousel, Video & Stories Formats",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Cross-Platform Ad Sync",
      description: "Unified strategy across all major ad platforms.",
      details: [
        "Google, Meta, LinkedIn, YouTube, Twitter",
        "Real-Time Pixel & Event Tracking",
        "Omnichannel Funnel Mapping",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Dynamic Product Ads",
      description: "Show the exact product users viewed earlier.",
      details: [
        "E-commerce Retargeting Catalog Setup",
        "Real-Time Price & Inventory Sync",
        "Abandoned Product Reminder Campaigns",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Audience Segmentation & Funnels",
      description: "Granular control over remarketing journeys.",
      details: [
        "Segment Based on Time-on-Site, Bounce, Scroll",
        "Cold vs Warm vs Hot User Funnels",
        "Exclusion & Frequency Rules",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Conversion Tracking & Optimization",
      description: "Optimize for return on ad spend (ROAS).",
      details: [
        "A/B Testing Creative & Offers",
        "Click-Through to Conversion Attribution",
        "Smart Bidding Strategies",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Remarketing Plan",
      price: "",
      features: [
        "Google Display Retargeting",
        "1 Custom Audience",
        "Basic Pixel Setup",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Multi-Platform Retargeting",
      price: "",
      features: [
        "Google + Facebook Setup",
        "Dynamic Product Ads",
        "Advanced Tracking + Funnels",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Advanced E-commerce Remarketing",
      price: "",
      features: [
        "Cross-Platform Strategy",
        "Catalog Feed + Real-Time Sync",
        "Omnichannel Campaign Management",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "What is the difference between remarketing and retargeting?",
      answer:
        "Remarketing typically refers to email or direct outreach, while retargeting uses paid ads to re-engage users who visited your website or app.",
    },
    {
      question: "Can I retarget users across multiple platforms?",
      answer:
        "Yes. We can run synced retargeting campaigns on Google, Meta (Facebook/Instagram), YouTube, and more.",
    },
    {
      question: "Do you offer product-specific retargeting for e-commerce?",
      answer:
        "Absolutely. We set up dynamic ads that show previously viewed or abandoned products to users on multiple platforms.",
    },
    {
      question: "Is conversion tracking included?",
      answer:
        "Yes. We implement full conversion tracking with pixels, events, and analytics integration to measure ROI precisely.",
    },
    {
      question: "Will users see my ads too frequently?",
      answer:
        "No. We use frequency caps and time windows to avoid overexposure and maintain a positive brand experience.",
    },
    {
      question: "Do I need to provide creative assets?",
      answer:
        "You can, but we also offer ad copywriting, creative design, and testing support as part of our packages.",
    },
  ],
};
export const InfluencerMarketingPageDetails = {
  SeoName: {
    seotitle: "InfluencerMarketingPageDetailsseo",
  },
  title: "Influencer Marketing Services",
  subtitle:
    "Boost your brands reach and credibility through authentic partnerships with top influencers across Instagram, YouTube, and more.",
  coverimage: DigitalMarketingMain_CoverImage,
  coverImage: {
    src: DigitalMarketingMain_CoverImage,
    style: {
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  },

  section2: {
    tagline: "Influence that Converts",
    heading: "Partner with Influencers Who Match Your Brands Voice",
    description:
      "At Cyber Space Digital, we connect you with influencers who resonate with your target audience. Our full-service influencer marketing strategy delivers real engagement, brand trust, and measurable conversions.",
  },

  services: [
    {
      icon: DefaultIcon,
      title: "Instagram Influencer Campaigns",
      description:
        "Tap into highly engaged audiences with story and reel campaigns.",
      details: [
        "Niche-Based Creator Matching",
        "Story, Reel & Post Promotion",
        "Follower Quality & Engagement Analysis",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "YouTube Influencer Collaborations",
      description: "Leverage long-form content for product demos and reviews.",
      details: [
        "Product Placements & Unboxings",
        "Sponsored Video Integration",
        "Channel Category Alignment",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Micro & Nano Influencer Campaigns",
      description: "High-trust engagement from smaller, more focused creators.",
      details: [
        "Cost-Effective, Hyperlocal Reach",
        "Regional Language Support",
        "Multi-Creator Coordination",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Influencer Whitelisting & Ads",
      description:
        "Run paid ads using influencer handles for more credibility.",
      details: [
        "Facebook & Instagram Ads via Influencer Profiles",
        "Higher CTR & Lower CPC",
        "Performance-Based Amplification",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "Influencer Gifting & Barter",
      description: "Low-budget brand awareness via barter deals.",
      details: [
        "Product Sampling Campaigns",
        "Story Mentions in Exchange for Gifts",
        "Suitable for D2C & Startups",
      ],
      link: "/contactus",
    },
    {
      icon: DefaultIcon,
      title: "End-to-End Influencer Management",
      description: "We handle everything ” from scouting to reporting.",
      details: [
        "Influencer Discovery & Onboarding",
        "Briefing, Coordination & Posting",
        "ROI Tracking & Campaign Reports",
      ],
      link: "/contactus",
    },
  ],

  pricing: [
    {
      title: "Starter Creator Package",
      price: "",
      features: [
        "1 Instagram Story + Post",
        "Micro/Nano Influencer",
        "Brand Tag & CTA Included",
      ],
      link: "/contactus",
      highlighted: false,
    },
    {
      title: "Multi-Creator Boost Plan",
      price: "",
      features: [
        "Up to 5 Micro Influencers",
        "Platform Mix (IG + YouTube)",
        "Performance Report & Tracking",
      ],
      link: "/contactus",
      highlighted: true,
    },
    {
      title: "Premium Influencer Activation",
      price: "",
      features: [
        "High-Reach Influencers (100k+)",
        "Product Demo/Review Video",
        "Paid Ad Whitelisting Included",
      ],
      link: "/contactus",
      highlighted: false,
    },
  ],

  faqs: [
    {
      question: "How do you select the right influencers for my brand?",
      answer:
        "We analyze your target audience, industry, and campaign goals to shortlist influencers with the right follower base, engagement rate, and content style.",
    },
    {
      question: "Do you work with influencers across India?",
      answer:
        "Yes. We work with creators across all major Indian languages and regions, including metro, Tier 1, and Tier 2 audiences.",
    },
    {
      question: "Is influencer marketing measurable?",
      answer:
        "Absolutely. We provide insights on reach, impressions, link clicks, and conversions wherever possible using tracking tools and influencer reports.",
    },
    {
      question: "Can I run influencer ads from their profiles?",
      answer:
        "Yes. We support influencer whitelisting, which allows us to run paid ads using their verified accounts ” enhancing ad trust and performance.",
    },
    {
      question: "What platforms do you cover?",
      answer:
        "We support Instagram, YouTube, Facebook, and emerging platforms like Moj and Josh based on your audience.",
    },
    {
      question: "Can you manage the campaign from start to finish?",
      answer:
        "Yes, we offer full-service influencer campaign management including contracts, creative briefs, timelines, coordination, posting, and reporting.",
    },
  ],
};

//branding
